import { getColorTheme } from '~/src/dash/resellers/utils/importResellerConfig';

export const hexToRgb = (input: any): string => {
  input = input + '';
  input = input.replace('#', '');
  const hexRegex = /[0-9A-Fa-f]/g;
  if (!hexRegex.test(input) || (input.length !== 3 && input.length !== 6)) {
    throw new Error('input is not a valid hex color.');
  }
  let first, second, last: any;
  if (input.length === 3) {
    first = input[0];
    second = input[1];
    last = input[2];
    input = first + first + second + second + last + last;
  }
  input = input.toUpperCase(input);
  first = input[0] + input[1];
  second = input[2] + input[3];
  last = input[4] + input[5];
  return parseInt(first, 16) + ', ' + parseInt(second, 16) + ', ' + parseInt(last, 16);
};

// ##############################
// // // Variables - Styles that are used on more than one component
// #############################

export const drawerWidth = 260;

export const deleteColor = '#707070';

export const backgroundColor = '#F8FAFF';

export const adminDebugColor = '#EAEFFD';

export const smallRadius = '5px';
export const bigRadius = '10px';

export const transition = {
  transition: 'all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)',
};

export const container = {
  paddingRight: '15px',
  paddingLeft: '15px',
  marginRight: 'auto',
  marginLeft: 'auto',
};

export const primaryColor = [
  getColorTheme('menuBarSelected'),
  getColorTheme('menuBarHovered'),
  getColorTheme('default'),
  getColorTheme('default'),
  getColorTheme('default'),
]; // Used on some primary buttons
export const warningColor = ['#ff9800', '#ffa726', '#fb8c00', '#ffa21a'];
export const dangerColor = ['#f44336', '#ef5350', '#e53935', '#f55a4e'];
export const successColor = ['#4caf50', '#66bb6a', '#43a047', '#5cb860'];

export const grayColor = [
  '#333',
  '#555555',
  '#777',
  '#999',
  '#AAAAAA',
  '#D2D2D2',
  '#DDD',
  '#b4b4b4',
  '#a9afbb',
  '#eee',
];
export const blackColor = '#000';
export const whiteColor = '#FFF';

export const boxShadow = {
  boxShadow:
    '0 10px 30px -12px rgba(' +
    hexToRgb(blackColor) +
    ', 0.42), 0 4px 25px 0px rgba(' +
    hexToRgb(blackColor) +
    ', 0.12), 0 8px 10px -5px rgba(' +
    hexToRgb(blackColor) +
    ', 0.2)',
};
export const successBoxShadow = {
  boxShadow:
    '0 4px 20px 0 rgba(' +
    hexToRgb(blackColor) +
    ',.14), 0 7px 10px -5px rgba(' +
    hexToRgb(successColor[0]) +
    ',.4)',
};
export const warningBoxShadow = {
  boxShadow:
    '0 4px 20px 0 rgba(' +
    hexToRgb(blackColor) +
    ',.14), 0 7px 10px -5px rgba(' +
    hexToRgb(warningColor[0]) +
    ',.4)',
};
export const dangerBoxShadow = {
  boxShadow:
    '0 4px 20px 0 rgba(' +
    hexToRgb(blackColor) +
    ',.14), 0 7px 10px -5px rgba(' +
    hexToRgb(dangerColor[0]) +
    ',.4)',
};

export const primaryFreeTrialCardHeader = {
  background: 'linear-gradient(60deg, #4FC1B5, #4952FF)',
  ...successBoxShadow,
};
export const warningCardHeader = {
  background: 'linear-gradient(60deg, ' + warningColor[1] + ', ' + warningColor[2] + ')',
  ...warningBoxShadow,
};
export const dangerCardHeader = {
  background: 'linear-gradient(60deg, ' + dangerColor[1] + ', ' + dangerColor[2] + ')',
  ...dangerBoxShadow,
};

export const alignRight = {
  'justify-content': 'flex-end',
  display: 'flex',
};

export const iconButton = {
  cursor: 'pointer',
  color: grayColor[3],
  '&:hover': {
    color: 'rgba(0, 0, 0, 0.87)',
  },
};

export const growGrid = {
  display: 'flex',
  'justify-content': 'space-around',
  'flex-flow': 'row nowrap',
  'align-items': 'flex-end',
};

export const growGridLeft = {
  'flex-grow': 1,
};

export const growGridRight = {
  marginLeft: '1rem',
  alignSelf: 'normal',
};

export const errorColor = {
  color: 'red',
};
